import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Table, DateTimeUtils, ClippedContent } from 'dyl-components';
import { Link } from 'react-router-dom';
import Avatar from 'react-avatar';
import noteType from './NoteType';
import EditCallNotesAction from './EditCallNotesModal';

export const NotesRow = ({ note, contactAccount, masterAccount, account, pipeline_id, refresh }) => {
    const name = `${note?.user?.first_name} ${note?.user?.last_name}`;
    const user_id = note?.user?.id || 0;
    const contactAccountName = contactAccount === "account" ? note?.contact ? `${note.contact?.first_name} ${note.contact?.last_name}` : account?.name : contactAccount === "master_account" && note.accountName !== "master_account" ? note.accountName : masterAccount?.name;
    const noteLinked = (contactAccount !== "contact" && !note.linked) && !pipeline_id; 
    const sub_type = note.sub_type;
    const isCallLog = sub_type === 'Call' && note.type !== "task";
    return (
        <>
            <Table.Row key={note.id}>
                <Table.Cell width={2}>
                    <div className={noteLinked ? 'Note__Disabled' : ''}><strong>{DateTimeUtils.formatEpoch(note.ts, "M[/]D[/]Y")}</strong></div>
                    <div className={noteLinked ? 'Note__Disabled' : ''}>{DateTimeUtils.formatEpoch(note.ts)}</div>
                </Table.Cell>
                <Table.Cell width={2}>
                    <div style={{width:150}} className={noteLinked ? 'Note__Disabled' : ''}>{noteType(sub_type, note?.task_name, contactAccount === "contact" || pipeline_id ? note?.contact_id : note?.contact?.id, note?.type)}</div>
                </Table.Cell>
                {(contactAccount === "account" || contactAccount === "master_account") &&
                    <Table.Cell width={2}>
                        <Grid verticalAlign={noteLinked ? '' : 'middle'}>
                            <Grid.Column width={4} style={{paddingLeft: 0, paddingRight: 0}}>
                                <Avatar
                                    name={contactAccountName}
                                    maxInitials={2}
                                    round
                                    size='3em'
                                />  
                            </Grid.Column>
                            <Grid.Column width={8} style={{paddingLeft: 0, paddingRight: 0}}> 
                                <Grid.Row>
                                    <ClippedContent>
                                        {(() => {
                                            if (contactAccount === "account") {
                                                if (note.contact) {
                                                    return <Link to={`/contact/${note.contact.id}`}>{contactAccountName}</Link>;
                                                } else {
                                                    return contactAccountName;
                                                }
                                            } 
                                            if (contactAccount === "master_account" && note.accountName !== "master_account") {
                                                return <Link to={`/account/${note.contact_id}`}>{contactAccountName}</Link>;
                                            }
                                            return contactAccountName;
                                        })()}
                                    </ClippedContent>
                                </Grid.Row>
                                {noteLinked &&
                                    <Grid.Row>
                                        <div className='Note__Disabled'><i>(unlinked)</i></div>
                                    </Grid.Row>
                                }
                            </Grid.Column>
                        </Grid>
                    </Table.Cell>
                }
                <Table.Cell width={2}>
                    <Grid verticalAlign='middle'>
                        <Grid.Column width={pipeline_id ? 5 : 4} style={{ paddingLeft: 0, paddingRight: 0 }}>
                            <Avatar
                                name={name}
                                maxInitials={2}
                                round
                                size='3em'
                            />
                        </Grid.Column>
                        <Grid.Column width={8} style={{ paddingLeft: 0, paddingRight: 0 }}>
                            <ClippedContent>
                                <Link to={`/settings/users/${user_id}/general`}>{name}</Link>
                            </ClippedContent>
                        </Grid.Column>
                    </Grid>
                </Table.Cell>
                <Table.Cell width={5}>
                    <div className={noteLinked ? 'Note__Disabled' : ''}>{note.note}</div>
                </Table.Cell>
                {pipeline_id && <Table.Cell width={2}>
                        {isCallLog && (
                            <EditCallNotesAction
                                call_uuid={note.id}
                                refresh={refresh}
                                direction={note.type}
                            />
                        )}
                </Table.Cell>}
            </Table.Row>
        </>
    )
}
